// 导入Vue Router的路由创建函数和历史模式函数
import { createRouter, createWebHistory } from 'vue-router'

// 导入首页组件：TiktokQuery（查询功能）
import TiktokQuery from '../layout/TiktokQuery.vue'

// 导入充值功能组件
import Recharge from '../layout/Recharge.vue'

// 导入充值记录列表组件
import RechargeOrderList from '../layout/RechargeOrderList.vue'

// 导入API文档组件
import Doc from '@/layout/ApiDoc.vue';

// 导入VIP充值组件
import VipRecharge from "@/layout/VipRecharge.vue";

// 导入小程序VIP充值组件
import MiniProgramVipRecharge from '@/layout/MiniProgramVipRecharge.vue'
// 导入数据监控组件
import MonitorData from "@/layout/monitorData.vue";

// 导入测试组件
import TestComponent from "@/layout/TestComponent.vue";

// 导入系统设置组件
import SystemSettings from '@/layout/SystemSettings.vue'

// 导入账号权重查询组件
import WeightQuery from '@/layout/WeightQuery.vue'

// 导入站点关闭页面组件
import SiteClosed from '@/layout/SiteClosed.vue'

// 定义路由配置数组
const routes = [
    // 小程序充值页面路由
  {
    path: '/mini-recharge',
    name: 'MiniProgramVipRecharge',
    component: MiniProgramVipRecharge,
    meta: {
      title: '抖数君小程序VIP套餐充值'
    }
  },

  // 数据监控页面路由
  {
    path: '/monitor-data',
    name: 'MonitorData',
    component: MonitorData,
    meta: {
      title: '作品数据监控'
    }
  },

  // API开发文档路由
  {
    path: '/Api_Doc',
    name: 'Doc',
    component: Doc,
    meta: { title: 'API开发文档' }
  },

  // 首页路由：抖音查询功能
  {
    path: '/',
    name: 'TiktokQuery',
    component: TiktokQuery,
    meta: { title: '抖数君—作品分析建议优化平台' }
  },

  // 充值中心路由
  {
    path: '/recharge',
    name: 'Recharge',
    component: Recharge,
    meta: { title: '充值中心' }
  },

  // 充值记录路由
  {
    path: '/recharge-list',
    name: 'RechargeList',
    component: RechargeOrderList,
    meta: { title: '充值记录' }
  },

  // VIP充值路由（需要登录验证）
  {
    path: '/vip-recharge',
    name: 'VipRecharge',
    component: VipRecharge,
    meta: {
      title: 'VIP充值',
      requiresAuth: true
    }
  },

  // 测试组件路由
  {
    path: '/test',
    name: 'TestComponent',
    component: TestComponent,
    meta: {
      title: '测试组件'
    }
  },

  // 系统设置路由
  {
    path: '/settings',
    name: 'Settings',
    component: SystemSettings,
    meta: {
      title: '系统基本设置'
    }
  },

  // 站点关闭页面路由
  {
    path: '/site-closed',
    name: 'SiteClosed',
    component: SiteClosed,
    meta: {
      title: '站点维护中'
    }
  },

  // 账号权重查询路由
  {
    path: '/weight-query',
    name: 'WeightQuery',
    component: WeightQuery,
    meta: {
      title: '账号权重查询'
    }
  },

  // 404页面路由：匹配所有未定义的路径
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../layout/404.vue'),
    meta: { title: '页面未找到' }
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory('/'),
  routes
})

// 全局导航守卫：路由跳转前的权限验证
router.beforeEach((to, from, next) => {
  // 从localStorage获取用户登录状态
  const isAuthenticated = localStorage.getItem('userLoggedIn') === 'true';

  // 定义无需认证的路径列表
  const allowedPaths = ['/mini-recharge', '/monitor-data', '/site-closed'];

  // 如果是无需认证的路径，直接放行
  if (allowedPaths.includes(to.path)) {
    next();
    return;
  }

  // 如果不是首页且用户未登录，则重定向到首页
  if (to.name !== 'TiktokQuery' && !isAuthenticated) {
    next({ name: 'TiktokQuery' });
  } else {
    next();
  }
});

// 导出路由实例
export default router